import React, { useState } from "react";
import { ErrorMessage, Field } from "formik";
import { useDispatch } from "react-redux";
import CustomMultiSelect from "../../components/inputs/multiSelect";
import TooltipTwyny from "../../components/tooltip";
import How from "../../components/how";
import {
  createEtablissementService,
  getMyEtablissement,
  updatePrestation,
} from "../../store/slices/etablissementSlice";
import { toast } from "react-toastify";
import { Helmet, HelmetProvider } from "react-helmet-async";

const PrestationCard = ({
  onSaveSuccess,
  prestation,
  prestationIndex,
  serviceIndex,
  handleChange,
  handleBlur,
  touched,
  errors,
  setFieldValue,
  values,
  removePrestation,
  allPrestations,
  currentPrestationKey,
  serviceName,
  serviceId,
  prestationId,
  service,
  lieuEtablissement,
  dragHandleProps,
  orderLoading
}) => {
  // Get all prestations from the current service (excluding current prestation)
  // console.log({errors})
  const complementaryOptions = service.prestations
    .filter((p, idx) => {
      // Exclude current prestation
      if (idx === prestationIndex) return false;

      // Only include prestations that have at least one matching location
      if (!prestation.lieu || !p.lieu) return false;

      // Check if any location matches between current prestation and this one
      return prestation.lieu.some((location) => p.lieu.includes(location));
    })
    .map((prestation) => ({
      label: prestation.name,
      value: prestation.prestationId,
    }));

  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();
  const calculateTTC = (ht, tva) => {
    const htValue = parseFloat(ht) || 0;
    const tvaValue = parseFloat(tva) || 0;
    return htValue * (1 + tvaValue / 100);
  };

  const handlePriceChange = (e, fieldName) => {
    handleChange(e);
    // Validate minimum HT price
    // if (fieldName === "ht") {
    //   const htValue = parseFloat(e.target.value);
    //   if (htValue < 10) {
    //     toast.error("Le prix HT minimum est de 10€");
    //     return;
    //   }
    // }
    const newHt = fieldName === "ht" ? e.target.value : prestation.ht;
    const newTva =
      fieldName === "taux_tva" ? e.target.value : prestation.taux_tva;
    const ttc = calculateTTC(newHt, newTva);
    setFieldValue(
      `services[${serviceIndex}].prestations[${prestationIndex}].ttc`,
      ttc.toFixed(2)
    );
  };
  const removeHowOption = (optionToRemove) => {
    const updatedLieux = prestation.lieu.filter(
      (option) => option !== optionToRemove
    );

    // Use setFieldValue to update the Formik state
    setFieldValue(
      `services[${serviceIndex}].prestations[${prestationIndex}].lieu`,
      updatedLieux
    );
  };
  const handleSave = async (e) => {

    e.preventDefault();
    // Validate required fields
    const requiredFields = ["name", "duree", "lieu", "ht"];
    const hasErrors = requiredFields.some((field) => {
      // console.log(field)
      const value = prestation[field];
      // console.log({value})
      if (field === "lieu") {
        // console.log('laaaaa')
        return !value || !Array.isArray(value) || value.length === 0;
      }

      return String(value).trim() === "";
    });

    // Additional length validations
    if (prestation.name && prestation.name.length > 50) {
      toast.error("Le nom de la prestation ne doit pas dépasser 50 caractères");
      return;
    }
    if (serviceName && serviceName.length > 30) {
      toast.error("Le nom du service ne doit pas dépasser 30 caractères");
      return;
    }
    if (prestation.description && prestation.description.length > 500) {
      toast.error("La description ne doit pas dépasser 500 caractères");
      return;
    }
    // Validate minimum HT price
    if (parseFloat(prestation.ht) < 10) {
      toast.error("Le prix HT minimum est de 10€");
      return;
    }
    if (hasErrors) {
      toast.error(
        "Veuillez remplir tous les champs obligatoires : Nom, Durée, Lieux d'intervention, prix HT."
      );
      return;
    }

    try {
      let response;
      if (!serviceId) {
        // First save: send with service name
        if (
          !serviceName ||
          typeof serviceName !== "string" ||
          serviceName.trim() === ""
        ) {
          alert("Le nom du service est requis pour enregistrer la prestation.");
          return;
        }
        const serviceData = {
          name: serviceName,
          prestations: [
            {
              ...prestation,
              lieu_intervention: prestation?.lieu,
              prestation_complementaire: Array.isArray(
                prestation.prestation_complementaire
              )
                ? prestation.prestation_complementaire
                : [],
            },
          ],
        };
        // console.log({serviceData})
        response = await dispatch(
          createEtablissementService(serviceData)
        ).unwrap();
        toast.success("Service et prestation ajouté avec succès"); // Success toast
      } else {
        // Subsequent saves: send with service_id
        const prestationData = {
          service_id: serviceId,
          name: serviceName,
          prestations: [
            {
              ...prestation,
              lieu_intervention: prestation?.lieu,
              prestation_complementaire: Array.isArray(
                prestation.prestation_complementaire
              )
                ? prestation.prestation_complementaire
                : [],
            },
          ],
        };
        const prestationDataToUpdate = {
          ...prestation,
          service_id: serviceId,
          service_name: serviceName,
          lieu_intervention: prestation?.lieu,
          prestation_complementaire: Array.isArray(
            prestation.prestation_complementaire
          )
            ? prestation.prestation_complementaire
            : [],
        };
        // console.log({prestationDataToUpdate})
        if (prestationId) {
          // Update existing prestation
          await dispatch(
            updatePrestation({ id: prestationId, ...prestationDataToUpdate })
          );
          toast.success("Prestation Modifié avec succès"); // Success toast
        } else {
          await dispatch(
            createEtablissementService(prestationData)

          ).unwrap();
          toast.success("Prestation ajouté avec succès"); // Success toast
        }
      }
      setIsOpen(false);
      // After successful save, dispatch action to get updated establishment
      onSaveSuccess();
      // Collapse accordion on success
    } catch (error) {
      // console.error("Save error:", error);
      // alert("Erreur lors de l'enregistrement. Veuillez réessayer.");
      toast.error("Erreur lors de l'enregistrement. Veuillez réessayer"); // Success toast
    }
  };

  const filteredPrestations = allPrestations.filter(
    (p) => p?.value !== currentPrestationKey
  );

  // First, define a mapping between the location values and their labels
  const locationOptionsMap = {
    onsite: { label: "À domicile", value: "onsite" },
    enligne: { label: "En ligne", value: "enligne" },
    chezpro: { label: "Chez le professionnel", value: "chezpro" },
  };

  // Then get the establishment's available locations (assuming it's in your form values)
  const availableLocations = lieuEtablissement || []; // e.g. ["enligne", "chezpro"]

  // Filter and map the options based on available locations
  const filteredLocationOptions = availableLocations.map(
    (loc) => locationOptionsMap[loc]
  );
  return (
    <div className="prestation-card badge-pre p-16 mb-16 mt-16">
      <HelmetProvider>
        <Helmet>
          <title>Inscription Prestataire </title>
          <meta
            name="description"
            content="Inscription Prestataire étape ajout catégories et prestations"
          />
        </Helmet>
      </HelmetProvider>
      <div className="d-flex justify-content-between" {...dragHandleProps}>
        <p className="body bold500 grey500">

          {!orderLoading ? (
            <img
              src="/images/drag.svg"
              alt="Déplacer"
              style={{
                width: "20px",
                height: "20px",
                marginRight: "10px",
                verticalAlign: "middle",
              }}
            />
          ) : <img
            src="/images/Loading_2.gif"
            alt="Déplacer"
            style={{
              width: "20px",
              height: "20px",
              marginRight: "10px",
              verticalAlign: "middle",
            }}
          />}
          {prestation.name || `Prestation n°${prestationIndex + 1}`}
        </p>
        <button
          type="button"
          className="link-blue"
          onClick={() => setIsOpen(!isOpen)}
          aria-label={isOpen ? "Réduire la prestation" : "Ouvrir la prestation"}
        >
          <img
            src={
              isOpen ? "/images/chevron-down.svg" : "/images/chevron-down.svg"
            }
            className="w-6 h-6"
            alt={isOpen ? "Réduire" : "Ouvrir"}
          />
        </button>
      </div>

      {isOpen && (
        <>
          <div className="input-wrapper">
            <label className="form-label">Nom de la prestation*</label>
            <Field
              name={`services[${serviceIndex}].prestations[${prestationIndex}].name`}
              className="form-control"
              onChange={handleChange}
              onBlur={handleBlur}
              aria-required="true"
              maxLength={50}
            />
            <ErrorMessage
              name={`services[${serviceIndex}].prestations[${prestationIndex}].name`}
              component="div"
              className="error-message mt-1"
            >
              {(msg) => (
                <div className="error-message mt-1">
                  <img
                    src="/images/alert-circle.svg"
                    className="arrow mr-8"
                    alt="Error"
                  />
                  {msg || "Ce champ est requis"}
                </div>
              )}
            </ErrorMessage>
          </div>
          <Field
            type="hidden"
            name={`prestation[${prestationIndex}].order`}
            value={prestationIndex + 1}
          />
          <div className="row mt-16">
            <div className="col-md-6">
              <div className="input-wrapper">
                <label className="form-label">Durée(en minute)*</label>
                <Field
                  name={`services[${serviceIndex}].prestations[${prestationIndex}].duree`}
                  className="form-control"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Durée en minute"
                  aria-required="true"
                  type="number"
                  min={1}
                />
                <ErrorMessage
                  name={`services[${serviceIndex}].prestations[${prestationIndex}].duree`}
                  component="div"
                  className="error-message mt-1"
                >
                  {(msg) => (
                    <div className="error-message mt-1">
                      <img
                        src="/images/alert-circle.svg"
                        className="arrow mr-8"
                        alt="Error"
                      />
                      {msg || "La durée est requise"}
                    </div>
                  )}
                </ErrorMessage>
              </div>
            </div>
            <div className="col-md-6">
              <div className="input-wrapper">
                <label className="form-label">
                  Nombre de RDV
                  <TooltipTwyny
                    children={
                      <img
                        src="/images/information-circle-contained.svg"
                        alt="information icon"
                        className="ml-8"
                      />
                    }
                    className={"left100"}
                    text=" Vos prestations peuvent se passer sur plusieurs séances, précisez le nombre de séances  prévues sur le nombre  total d’heures indiquées"
                  />{" "}
                </label>
                <Field
                  type="number"
                  name={`services[${serviceIndex}].prestations[${prestationIndex}].nbr_sceance`}
                  className="form-control"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  min={1}
                  step={1}
                />
                <ErrorMessage
                  name={`services[${serviceIndex}].prestations[${prestationIndex}].nbr_sceance`}
                  component="div"
                  className="error-message mt-1"
                >
                  {(msg) => (
                    <div className="error-message mt-1">
                      <img
                        src="/images/alert-circle.svg"
                        className="arrow mr-8"
                        alt="Error"
                      />
                      {msg || "La durée est requise"}
                    </div>
                  )}
                </ErrorMessage>
              </div>
            </div>
          </div>

          <div className="row mt-16">
            <div className="col-md-4 input-wrapper">
              <label className="form-label">Prix HT (€)</label>
              <Field
                type="number"
                step="0.01"
                min={1}
                name={`services[${serviceIndex}].prestations[${prestationIndex}].ht`}
                className="form-control"
                onChange={(e) => handlePriceChange(e, "ht")}
                onBlur={handleBlur}
              />
            </div>
            <div className="col-md-4 input-wrapper">
              <label className="form-label">TVA (%)</label>
              <Field
                type="number"
                step="0.1"
                name={`services[${serviceIndex}].prestations[${prestationIndex}].taux_tva`}
                className=""
                value={prestation.taux_tva || 20}
                onChange={(e) => handlePriceChange(e, "taux_tva")}
                onBlur={handleBlur}
                aria-readonly="true"
                disabled
              />
            </div>
            <div className="col-md-4 input-wrapper">
              <label className="form-label">Prix TTC (€)</label>
              <Field
                type="number"
                min={1}
                step="0.01"
                name={`services[${serviceIndex}].prestations[${prestationIndex}].ttc`}
                className=""
                value={prestation.ttc || ""}
                disabled
                aria-readonly="true"
              />
            </div>
          </div>

          <div className="mt-16">
            <div className="input-wrapper">
              <label className="form-label">Description</label>
              <Field
                as="textarea"
                name={`services[${serviceIndex}].prestations[${prestationIndex}].description`}
                className="form-control"
                rows={5}
                maxLength={500}
                onChange={handleChange}
                onBlur={handleBlur}
              />
              <ErrorMessage
                name={`services[${serviceIndex}].prestations[${prestationIndex}].description`}
              >
                {(msg) => (
                  <div className="error-message mt-1">
                    <img
                      src="/images/alert-circle.svg"
                      className="arrow mr-8"
                      alt="Error"
                    />
                    {msg}
                  </div>
                )}
              </ErrorMessage>
            </div>
          </div>

          <div className="col-md-12 mt-24">
            <div className="input-wrapper">
              <label>Lieux d'intervention*</label>

              <CustomMultiSelect
                // options={[
                //   { label: "À domicile", value: "onsite" },
                //   { label: "En ligne", value: "enligne" },
                //   { label: "Chez le professionnel", value: "chezpro" },
                // ]}
                options={filteredLocationOptions}
                placeholder="Sélectionnez les options"
                onChange={(selectedValues) =>
                  setFieldValue(
                    `services[${serviceIndex}].prestations[${prestationIndex}].lieu`,
                    selectedValues
                  )
                }
                selectedValues={prestation.lieu || []}
                aria-required="true"
              />

              {filteredLocationOptions.length === 0 && (
                <span className="error-message mt-8">
                  <img
                    src="/images/alert-circle.svg"
                    className="arrow mr-8"
                    alt="Arrow"
                  />
                  Vous devez tout d'abord sélectionner Lieux d'intervention dans
                  la section Type d'activité
                </span>
              )}
              {touched.services?.[serviceIndex]?.prestations?.[prestationIndex]
                ?.lieu &&
                errors.services?.[serviceIndex]?.prestations?.[prestationIndex]
                  ?.lieu && (
                  <div className="error-message">
                    {
                      errors.services[serviceIndex].prestations[prestationIndex]
                        .lieu
                    }
                  </div>
                )}
              <div className="mt-8">
                <How
                  lieu_intervention={prestation.lieu || []}
                  setHow={setFieldValue}
                  todelete={true}
                  serviceIndex={serviceIndex}
                  prestationIndex={prestationIndex}
                  className="badge-dark"
                  onRemoveOption={removeHowOption}
                  from="type"
                />
              </div>
            </div>
          </div>

          <div className="d-flex mt-8">
            <div className="col-auto">
              <img src="/images/annotation-information.svg" alt="info" />
            </div>
            <div className="col-md-8">
              <ul>
                <li className="grey66 legend">
                  À domicile correspond au domicile du client.
                </li>
                <li className="grey66 legend">
                  En ligne correspond au rendez-vous visioconférence organisé
                  automatiquement par Twyny.
                </li>
                <li className="grey66 legend">
                  Chez le professionnel correspond à votre cabinet/magasin.
                </li>
              </ul>
            </div>
          </div>

          <div className="col-md-12 mt-24">
            <div className="input-wrapper">
              <label>
                Associer une prestation complémentaire*
                <TooltipTwyny
                  children={
                    <img
                      src="/images/information-circle-contained.svg"
                      alt="information icon"
                      className="ml-8"
                    />
                  }
                  text="Vous pouvez sélectionner  des prestations complémentaires réalisables  
                  sur le même temps. Twyny les recommandera en complément lors de la réservation de cette prestation."
                />
              </label>

              <CustomMultiSelect
                options={complementaryOptions}
                placeholder="Sélectionnez les prestations complémentaires"
                onChange={(selectedValues) =>
                  setFieldValue(
                    `services[${serviceIndex}].prestations[${prestationIndex}].prestation_complementaire`,
                    selectedValues
                  )
                }
                selectedValues={prestation.prestation_complementaire || []}
              />

              {complementaryOptions.length === 0 && (
                <span className="error-message mt-8">
                  <img
                    src="/images/alert-circle.svg"
                    className="arrow mr-8"
                    alt="Arrow"
                  />
                  Créez d'abord d'autres prestations pour pouvoir les associer à
                  celle-ci
                </span>
              )}
              <div className="selected-prestations-container service-badges  mt-2">
                {prestation.prestation_complementaire.map(
                  (prestationId, index) => {
                    // console.log({prestationId})
                    const associatedPrestation = allPrestations.find(
                      (p) => p.value == prestationId
                    );
                    return (
                      <div
                        key={index}
                        className="badge-dark service-badge d-flex selected-prestation-badge align-items-center"
                      >
                        <span>
                          {associatedPrestation?.label || "Prestation inconnue"}
                        </span>
                        <button
                          type="button"
                          className="link-blue ml-8"
                          onClick={() => {
                            const updated = (
                              prestation.prestation_complementaire || []
                            ).filter((id) => id !== prestationId);
                            setFieldValue(
                              `services[${serviceIndex}].prestations[${prestationIndex}].prestation_complementaire`,
                              updated
                            );
                          }}
                          aria-label={`Supprimer ${associatedPrestation?.label || "prestation"
                            }`}
                        >
                          <img src="/images/x-03.svg" alt="x icon" />
                        </button>
                      </div>
                    );
                  }
                )}
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-end mb-8 mt-16">
            <button
              type="button"
              className="twyny-cta-primary w-100 mr-8"
              onClick={handleSave}
              aria-label="Enregistrer la prestation"
            >
              Enregistrer
            </button>
            <button
              type="button"
              className="twyny-cta-secondary btn-withIcon btn-sm"
              onClick={() => removePrestation(prestationIndex)}
              aria-label={`Supprimer Prestation ${prestationIndex + 1}`}
            >
              <img src="/images/trash.svg" className="arrow" alt="Delete" />
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default PrestationCard;
